// Überprüfen, ob es sich um ein mobiles Gerät handelt
window.addEventListener("load", function () {
	console.log("scroll position");

	var isMobile = window.innerWidth <= 768;
	if (isMobile) {
		// Funktion zum Speichern der aktuellen Scroll-Position
		function saveScrollPosition() {
			sessionStorage.setItem("scrollPosition", window.scrollY);
		}

		// Funktion zum Wiederherstellen der gespeicherten Scroll-Position
		function restoreScrollPosition() {
			const savedPosition = sessionStorage.getItem("scrollPosition");
			if (savedPosition) {
				window.scrollTo(0, parseInt(savedPosition));
			}
		}

		// Event-Listener, um die Scroll-Position beim Verlassen der Seite zu speichern
		window.addEventListener("beforeunload", saveScrollPosition);

		// Event-Listener, um die Scroll-Position beim Laden der Seite wiederherzustellen
		window.addEventListener("load", restoreScrollPosition);
	}
});
